import { render, staticRenderFns } from "./spineRisk.vue?vue&type=template&id=5a191497&scoped=true&"
import script from "./spineRisk.vue?vue&type=script&lang=js&"
export * from "./spineRisk.vue?vue&type=script&lang=js&"
import style0 from "./spineRisk.vue?vue&type=style&index=0&id=5a191497&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a191497",
  null
  
)

export default component.exports